// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"efeca4dc","555":"6e5ef887","587":"0efa8a14","629":"c755189f","797":"8590dd4d","891":"dd8aeddb","937":"99bf7d43"}[chunkId] + ".chunk.js";
};